import React from "react"

import { ProjectChildMultiSelectSidebar } from "./ProjectChildMultiSelectSidebar"
import {
  UseProjectChildMultiSelectSidebarModelArgs,
  useProjectChildMultiSelectSidebarModel
} from "./hooks/useProjectChildMultiSelectSidebarModel"

export const ProjectChildMultiSelectSidebarConnector = React.memo(
  (props: UseProjectChildMultiSelectSidebarModelArgs) => (
    <ProjectChildMultiSelectSidebar
      {...useProjectChildMultiSelectSidebarModel(props)}
    />
  )
)
